module.exports = __webpack_public_path__ + "img/app-logo.19471d3c.png";